import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faPlus } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import { SiteHeader } from "../../components/header/header";
import { categories, brands } from "../../_helpers/mock-data";
import { useProduct } from "../../services/products/product.context";
import { FooterComponent } from "../../components/footer/footer";

export const AdminDashboard = () => {

    const [listIndx, setListIndx] = useState();
    const [inventory, setInventory] = useState([]);

    const { allProducts } = useProduct();

    const navigateTo = useNavigate();

    useEffect(() => {
        ( async () => {
            
            setInventory(allProducts);
        })();
    } ,[allProducts])

    //generate an array of all brand of products in stock for each category
    const getCategoryBrands = (category) => {
        const  brandMixed = inventory?.filter((product) => product.category === category)
        .map((prod) => prod.brand);

        return Array.from(new Set(brandMixed));
    }

    //get logos for a brand from the logos collection 
    const getBrandLogo = (brand) => {
        return brands.find((br) => br.name === brand).logo; 
    }

    return (
        <div className="page-body">
            <SiteHeader pageTitle={'Dasboard'} />
            <div className="dashboard-data">
                <div className="top-button-box">
                    <button className="top-button" onClick={() => navigateTo("/addproduct") }>
                        <FontAwesomeIcon icon={faPlus} className="top-bttn-icon" />
                        <span className="top-bttn-text">Add Product</span>
                    </button>
                    <button className="top-button" onClick={() => navigateTo("/update_delete") }>
                        <FontAwesomeIcon icon={faPlus} className="top-bttn-icon" />
                        <span className="top-bttn-text">Update Product</span>
                    </button>
                </div>
                <div className="product-data">
                    <div className="list-caption">Products in stock</div>
                    {categories?.map((cat, k) => (
                        <div className="cat-container-drp" key={k}>
                            {/* category button */}
                            <button
                                className="cat-label-button"
                                onClick={() => {
                                    listIndx === k ? setListIndx() : setListIndx(k)
                                }}
                            >
                                <img src={cat.icon} alt="" className="cat-img" />
                                <span className="cat-label">
                                    <span className="cat-label-nm">{cat.name}</span>
                                    <span className="cat-label-num">
                                        {"("}{inventory?.filter((product) => (
                                            product?.category === cat.name
                                        )).length}{")"}
                                    </span>
                                </span>
                                <span className="cat-drp-indic">
                                    <FontAwesomeIcon 
                                        icon={faChevronDown}
                                        className={classNames("norm",{"rot": listIndx === k})} 
                                    />
                                </span>
                            </button>
                            <div
                                className={classNames(
                                    "cat-product-list",
                                    { 'cat-shown': listIndx === k }
                                )}
                            >
                                {getCategoryBrands(cat.name)?.map((brand, k) => (
                                    <button className="brand-type-button" key={k}>
                                        <span className="br-info">
                                            <img className="br-sm" src={getBrandLogo(brand)} alt="" />
                                            <span className="brand-name">{brand}</span>
                                        </span>

                                        <span className="brand-num">
                                            {inventory?.filter((pr) => pr.brand === brand && pr.category === cat.name).length}
                                        </span>
                                    </button>
                                ))

                                }
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <FooterComponent />
        </div>
    )
}